import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="select-updater"
// Handles select dropdown updates that submit on change
export default class extends Controller {
  static values = {
    url: String,
    param: String
  }

  connect() {
  }

  change(event) {
    const value = event.target.value

    // Build nested parameter structure if param contains brackets
    const data = this.buildNestedParams(this.paramValue, value)

    fetch(this.urlValue, {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (response.ok) {
        this.showSuccess(event.target)
      } else {
        this.showError()
      }
    })
    .catch(error => {
      console.error('Update error:', error)
      this.showError()
    })
  }

  showSuccess(select) {
    // Visual feedback
    const originalBg = select.style.backgroundColor
    select.style.backgroundColor = '#d4edda'
    setTimeout(() => {
      select.style.backgroundColor = originalBg
    }, 1000)
  }

  showError() {
    alert('There was an error that prevented this update.')
  }

  buildNestedParams(paramName, value) {
    // Parse parameter name like "master_recording[status]"
    // into nested structure { master_recording: { status: value } }
    const match = paramName.match(/^([^\[]+)\[([^\]]+)\]$/)

    if (match) {
      const [, parentKey, childKey] = match
      return { [parentKey]: { [childKey]: value } }
    } else {
      // Simple parameter without nesting
      return { [paramName]: value }
    }
  }
}
